interface BrandProps {
  compact?: boolean;
}

export function Brand({ compact = false }: BrandProps) {
  return (
    <div className={compact ? 'brand brand--compact' : 'brand'} aria-label="ModIQ">
      <svg width={compact ? 24 : 26} height={compact ? 24 : 26} viewBox="0 0 26 26" fill="none" aria-hidden="true">
        <path d="M2.5 15.5 A11 11 0 0 1 23.5 15.5" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" />
        <circle cx="13" cy="14" r="3.3" fill="var(--signal)" />
      </svg>
      <span>Mod<strong>IQ</strong></span>
    </div>
  );
}
